import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TableData } from 'src/app/shared/models/tableData';
import { ToolInventoryModalSearchComponent } from './search/tool-inventory-modal-search.component';
import { alert, assignment, model } from './tool-inventory-modal.functions';
import { ToolInventoryModalService } from './tool-inventory-modal.service';
import { ToolInventoryTransferService } from '../tool-inventory-transfer/tool-inventory-transfer.service';

@Component({
  selector: 'app-tool-inventory-modal',
  templateUrl: './tool-inventory-modal.component.html',
  styleUrls: ['./tool-inventory-modal.component.scss'],
})
export class ToolInventoryModalComponent implements OnInit {
  @ViewChild('transferSearch')
  @Output() transfer = new EventEmitter<any>();

  private toolTransferSearch: ToolInventoryModalSearchComponent;

  subscription: Subscription;

  tableData: TableData = {
    label: 'Tool',
    type: 'tools',
    selectable: false,
    statusToggle: false,
    noResultsMessage: 'No tools selected.',
    tableClasses: { fixed: true },
    columns: [
      {
        name: 'toolId',
        label: 'Tool ID',
        property: 'toolId',
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '104px', 'width': '100px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'tool_name',
        label: 'Tool Name',
        property: row => {
          return model(row, 'name');
        },
        sortable: false,
        columnStyles: { 'max-width': '210px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedTo',
        label: 'Assigned To',
        property: row => assignment(row, 'primaryAssignment'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '210px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignment',
        label: 'Status',
        property: row => assignment(row, 'type.name'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '104px' },
        dataClasses: row => {
          const type = assignment(row, 'type.name');
          return `status ${type && type.toLowerCase().replace(/\s/g, '-')}`;
        },
      },
      {
        name: 'assignedTo',
        label: 'Alert Code',
        property: row => (alert(row, 'enabled') && alert(row, 'message') ? alert(row, 'message') : ''),
        popover: row => alert(row, 'enabled'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '210px' },
        columnClasses: { 'text-truncate': false },
      },
    ],
    rowActions: [
      {
        label: 'Delete',
        iconName: 'far fa-times',
        show: x => true,
        click: (event, row) => {
          this.toolInventoryModalService.remove(row.id);
          this.toolTransferSearch.deselectItem(row.id);
        },
      },
    ],
    data: [],
    pagination: {},
  };

  inventoryModalIsOpen: boolean = false;

  constructor(
    private toolInventoryModalService: ToolInventoryModalService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.subscription = this.toolInventoryModalService.inventoryModalIsOpen.subscribe(value => (this.inventoryModalIsOpen = value));

    this.subscription = this.toolInventoryModalService.selectedInventoryItems.subscribe(data => (this.tableData.data = data));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.toolInventoryModalService.close();
      }
    });
  }

  handleClose() {
    this.toolInventoryModalService.close();
  }

  handleClear() {
    this.toolInventoryModalService.clear();
  }

  triggerTransfer() {
    const tableData = this.tableData.data
    this.toolInventoryTransferService.set(tableData)

    setTimeout(() => {
      this.toolInventoryTransferService.open()
      this.toolInventoryModalService.close()
    }, 300)
  }
}
